import React from "react";
import "./About.scss";
import image1 from "../../assets/logo-black.png";
import image2 from "../../assets/logo-black.png";
import image3 from "../../assets/logo-black.png";

const AboutPage = () => {
  return (
    
    <div className="container">
    <div className="about-page">
      <h1 className="about-page__heading">Pinch Harmonic Guitars</h1>
      <p>
        Welcome to Pinch Harmonic Guitars, your one-stop-shop for all things
        guitar-related! We are a family-owned and operated business based in
        Nashville, Tennesee, and we have been serving guitar enthusiasts of all
        levels for 84 years. At Pinch Harmonic Guitars, we are passionate about
        guitars, and we pride ourselves on our expertise and knowledge in the
        industry. We understand that every guitarist has unique preferences and
        needs, which is why we offer a wide selection of guitars and accessories
        to suit all styles and skill levels.
      </p>
      <img src={image1} className="about-page__image-right" alt="guitar" />
      <p>
        Whether you are a beginner looking for your first guitar or a seasoned
        professional in need of a custom build, our team of experts is here to
        help you find the perfect instrument for your needs. We carry a variety
        of top brands, including [brand names], as well as unique and
        hard-to-find guitars from independent luthiers. In addition to our
        selection of guitars, we also offer a range of accessories, including
        strings, picks, pedals, and amplifiers. Our staff is highly
        knowledgeable and can help you choose the perfect combination of gear to
        achieve your desired sound.
      </p>
      <img src={image2} className="about-page__image-left" alt="guitar" />
      <p>
        At Pinch Harmonic Guitars, we believe that every musician deserves
        high-quality instruments and gear, regardless of their budget. That's
        why we offer competitive pricing and financing options to help make your
        dream guitar a reality. We take pride in providing exceptional customer
        service and support. Whether you need advice on a purchase, technical
        assistance, or just want to chat about guitars, we are always here to
        help. Contact us today or visit us in-store to experience the Pinch
        Harmonic Guitars difference!
      </p>
      <img src={image3} className="about-page__image-right" alt="guitar" />
      <p>
        At Pinch Harmonic Guitars, we don't just sell guitars, we live and
        breathe music. Our passion for music is evident in everything we do,
        from our personalized service to our commitment to providing
        high-quality instruments and accessories. We also believe in giving back
        to the community. That's why we support local musicians and music
        education programs by sponsoring events and donating instruments to
        schools and organizations. In addition, we offer guitar lessons for
        players of all levels. Our experienced instructors can help you develop
        your skills and reach your musical goals, whether you're a beginner or
        an advanced player. At Pinch Harmonic Guitars, we are more than just a
        guitar shop – we are a community of passionate musicians who share a
        love of music and a dedication to excellence. Join us and discover the
        joy of playing the guitar!
      </p>
    </div>
    </div>
  );
};

export default AboutPage;
